import './style/index.less';
import Referrer from './Referrer';

export default Referrer;
